
// This is a strange class but I see no other way to do this in TypeScript

export class WeakPairList<P extends object, S> {
    private list: { map: WeakMap<P, S>, ref: WeakRef<P> } [] = []

    push(primary: P, secondary: S): void {
        this.list.push({ map: new WeakMap([[primary, secondary]]), ref: new WeakRef(primary) })
    }

    forEach(callback: (primary: P, secondary: S) => void): void {
        for(let index = 0; index < this.list.length; index++) {
            const primary = this.list[index].ref.deref()
            if(primary !== undefined) {
                const secondary = this.list[index].map.get(primary)
                if(secondary !== undefined) {
                    callback(primary, secondary)
                }
            } else {
                // Remove the whole entry
                this.list.splice(index, 1)
                index--
            }
        }
    }
}